/* eslint-disable */
require('./airplane')
require('./ship')
require('./truck')
